import axios from "axios";
import { config } from "../../api-helper/api-header-configs";

const baseURL = process.env.REACT_APP_API_URL;

// Create Subproject
export const create_subproject = async (values: any) => {
    const payload = {
        project_id: values.project_id,
        subproject_name: values.subproject_name,
        description: values.description || '',
        status: values.status || '1'
    };
    const response = await axios.post(baseURL + "/subprojects", payload, config);
    return response.data;
}

// List All Subprojects (optionally filter by project_id)
export const get_all_subprojects = async (projectId?: string) => {
    const params: any = {
        _t: Date.now() // Cache busting
    };
    if (projectId) {
        params.project_id = projectId;
    }
    const response = await axios.get(baseURL + "/subprojects", {
        params
    });
    return response.data;
}

// Get Single Subproject
export const get_subproject_by_id = async (subprojectId: string) => {
    const response = await axios.get(baseURL + `/subprojects/${subprojectId}`, config);
    return response.data;
}

// Update Subproject
export const update_subproject = async (subprojectId: string, values: any) => {
    const payload = {
        subproject_name: values.subproject_name,
        description: values.description || '',
        status: values.status || '1'
    };
    const response = await axios.patch(baseURL + `/subprojects/${subprojectId}`, payload, config);
    return response.data;
}

// Delete Subproject
export const delete_subproject = async (subprojectId: string) => {
    const response = await axios.delete(baseURL + `/subprojects/${subprojectId}`, config);
    return response.data;
}

